// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"d2452b86","container":"b9a8243f","rightPanelContainer":"e3be20bf","externalForm":"f7a66313"};